var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoProgressCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1057 9.36252L16.6942 11.0266L19.25 12.6696L19.25 3.33041H21V12.6696C21 14.0541 19.4683 14.8903 18.3037 14.1416L17.3698 13.5413L15.7479 12.4986C15.7257 13.1358 15.5333 13.7297 15.2146 14.2362C14.5952 15.2207 13.499 15.875 12.25 15.875H3.5C1.567 15.875 0 14.308 0 12.375V3.625C0 1.692 1.567 0.125 3.5 0.125H12.25C13.499 0.125 14.5952 0.779257 15.2146 1.76376C15.5333 2.27026 15.7257 2.86417 15.7479 3.50138L17.3698 2.45868L18.3037 1.85835C19.4683 1.10965 21 1.94587 21 3.33041L19.25 3.33041L18.3118 1.87098L19.25 3.33041L16.6942 4.97344L14.1057 6.63748L13.9989 3.56209C13.9664 2.62535 13.1955 1.875 12.25 1.875H3.5C2.5335 1.875 1.75 2.6585 1.75 3.625V12.375C1.75 13.3415 2.5335 14.125 3.5 14.125H12.25C13.1955 14.125 13.9664 13.3747 13.9989 12.4379L14.1057 9.36252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoProgressCamera);
export default __webpack_public_path__ + "static/media/video_progress_camera.81f423ca853b92fdcb91f3636983bc03.svg";
export { ForwardRef as ReactComponent };